import { of, BehaviorSubject, Subject } from "rxjs";
import { User, UserConfig, UserCredentials } from "./authTypes";
import { reloadCurrentViews, switchCognitoRole } from "./config";
import { setUserIsActiveInterval } from "./userActivity";
import { Environment } from "../types";

const developmentEnvironment = process.env.REACT_APP_ENVIRONMENT === Environment.DEV;
const qaEnvironment = process.env.REACT_APP_ENVIRONMENT === Environment.QA;

export const setUserConfig = (): UserConfig => ({
  user: {} as User,
  userObservable: new BehaviorSubject({} as User),
  factoryChangeObservable: new Subject<string>(),
  userIsActiveInterval: null,
  setUser: function (user: User) {
    this.user = { ...user };
    this.userObservable.next(user);
    this.userIsActiveInterval =
      (developmentEnvironment || qaEnvironment) && setUserIsActiveInterval();
  },
  setUserCredentials: function (credentials: UserCredentials) {
    const assignedCredentials = Object.assign(
      {},
      this.user.credentials,
      credentials
    );
    this.user = Object.assign({}, this.user, {
      credentials: assignedCredentials,
    });
    this.userObservable.next(this.user);
  },
  changeFactory: async function (factory: string) {
    try {
      await switchCognitoRole(factory);
      const user = {
        ...this.user,
        roleInCurrentFactory: this.user.roles.get(factory),
        factory,
      };
      this.factoryChangeObservable.next(factory);
      clearInterval(this.userIsActiveInterval);
      this.setUser(user);
      await reloadCurrentViews();
      return factory;
    } catch (error) {
      console.error(error);
    }
  },
  getUserCredentials(): UserCredentials {
    return { ...this.user.credentials };
  },
  getUserData: function () {
    return { ...this.user };
  },
  getAsyncUserData: function () {
    return of({ ...this.user }).toPromise();
  },
  getObservableUserData: function () {
    return this.userObservable.asObservable();
  },
  getFactoryChangeObservable: function () {
    return this.factoryChangeObservable.asObservable();
  },
  getUserIsActiveInterval: function () {
    return this.userIsActiveInterval;
  },
});
